var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGaugeSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.65 17h-4.532l1.776-3.553a1 1 0 1 0-1.789-.894l-2 4c-.072.144-.095.447-.095.447H9.349C9.128 16 9 15.702 9 15c0-3.309 2.691-6 6-6 3.308 0 6 2.691 6 6 0 .702-.128 1-.35 2M15 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
})));
export default SvgGaugeSolid;